import { transform } from '../../../unit/const'

export default {
  props: [
    'active',
    'color',
    'size',
    'top',
    'left',
    'label',
    'position',
    'arrow'
  ]
}



// WEBPACK FOOTER //
// ./src/components/keyboard/button/index.js